import React, { forwardRef, useEffect, useRef, useState } from 'react';

import './PricingPopup.scss';
import {
  Autocomplete,
  Dialog,
  IconButton,
  Slide,
  TextField,
  useMediaQuery,
} from '@mui/material';
import Title from '../../Title/Title';
import Description from '../../Description/Description';
import { ButtonPrimary } from '../../Button/Buttons';
import { useRecoilState } from 'recoil';
import { PricingPopupState } from '../../../recoil/PricingPopupState/PricingPopupState';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { ArrowSelect, CloseIcon } from '../../../assets/icons/Icons';

import emailjs from '@emailjs/browser';

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const PricingPopup = () => {
  const [open, setOpen] = useRecoilState(PricingPopupState);
  const isMobile = useMediaQuery('(max-width: 633px)');
  const form = useRef();

  const [countries, setCountries] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(countries[0]);

  const sendEmail = e => {
    e.preventDefault();

    emailjs
      .sendForm(
        'service_o2uie1n',
        'template_zur0pea',
        form.current,
        'MhiWBlUFIepxF4kou',
      )
      .then(() => {
        setOpen(false);
      });
  };

  useEffect(() => {
    fetch(
      'https://valid.layercode.workers.dev/list/countries?format=select&flags=true&value=code',
    )
      .then(response => response.json())
      .then(data => {
        setCountries(data.countries);
        setSelectedCountry(data.userSelectValue);
      });
  }, []);
  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={() => setOpen(false)}
      aria-describedby="alert-dialog-slide-description"
      className="PricingPopupDialog"
    >
      <div className="PricingPopupDialog__wrapper">
        {isMobile && (
          <IconButton
            onClick={() => setOpen(false)}
            className="PricingPopupDialog__wrapper__close"
          >
            <CloseIcon />
          </IconButton>
        )}

        <div className="PricingPopupDialog__wrapper__text">
          <Title>Pricing</Title>
          <Description>
            Introducing SIROCA LIMS, the cutting-edge Laboratory Information
            System designed to transform how laboratories process, analyze,
            and report data. Our solution offers unparalleled precision, speed,
            and usability.
          </Description>
        </div>
        <form ref={form} onSubmit={sendEmail}>
          <div className="PricingPopupDialog__wrapper__inputs">
            <TextField name="name" placeholder="Name" />
            <PhoneInput
              inputProps={{
                name: 'phone',
              }}
              country="kg"
              placeholder="Phone"
            />

            <TextField name="email" placeholder="E-mail" />

            <Autocomplete
              options={countries}
              value={selectedCountry}
              getOptionLabel={option => option.label}
              onChange={selectedOption => setSelectedCountry(selectedOption)}
              popupIcon={<ArrowSelect />}
              renderInput={params => (
                <TextField
                  {...params}
                  fullWidth
                  label="Country"
                  variant="outlined"
                  autoComplete="off"
                  name="country"
                  placeholder="Country"
                />
              )}
            />
          </div>
          <div className="PricingPopupDialog__wrapper__inputs__btn">
            <ButtonPrimary type="submit">Submit Your Application</ButtonPrimary>
          </div>
        </form>
      </div>
    </Dialog>
  );
};

export default PricingPopup;
